import { ServiceSchedules } from '@/service/schedules/serviceSchedules'

const serviceSchedules = new ServiceSchedules()
export default {
  namespaced: true,
  state: {
    agoraio_channel: '',
    agoraio_token: '',
    consultation_time: {
      date: '',
      init_hour: '',
      final_hour: '',
    },
  },
  getters: {
    agoraio_channel: state => state.agoraio_channel,
    agoraio_token: state => state.agoraio_token,
    consultation_time: state => state.consultation_time,
  },
  mutations: {
    setAgoraioChannel(state, agoraio_channel) {
      state.agoraio_channel = agoraio_channel
    },
    setAgoraioToken(state, agoraio_token) {
      state.agoraio_token = agoraio_token
    },
    setConsultationTime(state, consultation_time) {
      state.consultation_time = consultation_time
    },
  },
  actions: {
    async getTokenChannel({ commit }, id) {
      try {
        const response = await serviceSchedules.findByScheduleByCustomer(id)
        commit('setAgoraioChannel', response.agoraio_channel)
        commit('setAgoraioToken', response.agoraio_token)
        commit('setConsultationTime', {
          date: response.date,
          init_hour: response.init_hour,
          final_hour: response.final_hour,
        })
        return response.agoraio_channel
      } catch (error) {
        throw error
      }
    },
  },

}
